import React from 'react';
import {Modal} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import storeUtils from '../../utils/storeUtils';
import ConfirmDialog from '../dialogs/ConfirmDialog';
import {useSelector} from 'react-redux';
import smbUtils from '../../utils/smbUtils';
import OverLayLoader from '../spinner/OverLayLoader';

const UpgradeModal4ScpV1 = ({
  show,
  setShow,
  step,
  setStep,
  update,
  loading,
}) => {
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {customerId} = smbUtils.customerInfo(auth);

  return (
    <>
      <Modal
        size="lg"
        show={show}
        centered
        backdrop={'static'}
        enforceFocus={true}
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>
            {step === 0 && (
              <Trans i18nKey="c.a.upgrade.modal.title1">What’s New</Trans>
            )}
            {step === 1 && (
              <Trans i18nKey="c.a.upgrade.modal.title2">
                Update to Latest Version Now
              </Trans>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {step === 0 && (
            <>
              <div className="text-danger">
                <strong>
                  <Trans i18nKey="c.a.upgrade.modal.trial.simulation">
                    You need to update Console to trial Aesthetic Simulation
                    features!
                  </Trans>
                </strong>
              </div>
              <br />
              <Trans i18nKey="c.a.upgrade.modal.body1">
                <p>
                  Skincare Pro new features are here! Utilize Location
                  Management, and Client List to manage customer relationships.
                </p>
                <p>
                  Through these new features, Skincare Pro will automatically
                  record the responsible personnel for each client, as well as
                  their location visits, and skin detection history, making it
                  easy for you to track each client’s details.
                </p>
              </Trans>
              <div className="row">
                <div className="col-6">
                  <div className="text-center kt-margin-b-5">
                    <strong>
                      <Trans i18nKey="p.g.store.management.title">
                        Location Management
                      </Trans>
                    </strong>
                  </div>
                  <img
                    style={{maxWidth: '100%'}}
                    alt=""
                    src={
                      'https://plugins-media.makeupar.com/smb/story/2023-12-12/c9746461-793b-48b7-8910-83fd413996d6.png'
                    }
                  />
                  <div className="text-left">
                    <Trans i18nKey="c.a.upgrade.modal.body1.item1">
                      Record and manage client visits at each of your locations.
                    </Trans>
                  </div>
                </div>
                <div className="col-6">
                  <div className="text-center kt-margin-b-5">
                    <strong>
                      <Trans i18nKey="p.s.listcustomer.theme">
                        Client List
                      </Trans>
                    </strong>
                  </div>
                  <img
                    style={{maxWidth: '100%'}}
                    alt=""
                    src={
                      'https://plugins-media.makeupar.com/smb/story/2024-01-10/99e2d8cd-c37b-4bf0-899e-d07c3993d668.png'
                    }
                  />
                  <div className="text-left">
                    <Trans i18nKey="c.a.upgrade.modal.body1.item3">
                      View complete client information and skin detection
                      details.
                    </Trans>
                  </div>
                </div>
              </div>
            </>
          )}
          {step === 1 && (
            <>
              <Trans i18nKey="c.a.upgrade.modal.body2">
                <p>
                  To ensure you are able to access the new features seamlessly,
                  please update the UI Configuration pages to the latest
                  version.
                </p>
                <p className="kt-padding-l-20">
                  <li style={{listStyleType: 'none'}}>
                    <i className="fa fa-check-circle kt-margin-r-10 text-success" />
                    Complete UI Configuration support for the new CRM.
                  </li>
                  <li style={{listStyleType: 'none'}}>
                    <i className="fa fa-check-circle kt-margin-r-10 text-success" />
                    Apply the standard light mode for theme color.
                  </li>
                  <li style={{listStyleType: 'none'}}>
                    <i className="fa fa-check-circle kt-margin-r-10 text-success" />
                    Existing settings will be transferred automatically to the
                    new version
                  </li>
                  <li style={{listStyleType: 'none'}}>
                    <i className="fa fa-check-circle kt-margin-r-10 text-success" />
                    You will be able to check the settings in each tab and
                    explore more after the update.
                  </li>
                </p>
                <p>
                  This update cannot be reversed, please confirm before you
                  proceed. Remember to update the app on your mobile devices for
                  the complete experience.
                </p>
              </Trans>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            {step === 0 && (
              <>
                <button
                  className="btn btn-outline-secondary kt-margin-r-10"
                  onClick={() => {
                    storeUtils.setHideUpdatedModal(customerId, 1);
                    setStep(0);
                    setShow(false);
                  }}
                >
                  <Trans i18nKey="p.p.s.view.close">Close</Trans>
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    setStep(1);
                  }}
                >
                  <Trans i18nKey="p.p.s.view.next">Next</Trans>
                </button>
              </>
            )}
            {step === 1 && (
              <>
                <button
                  className="btn btn-outline-secondary kt-margin-r-10"
                  onClick={() => {
                    storeUtils.setHideUpdatedModal(customerId, 1);
                    setStep(0);
                    setShow(false);
                  }}
                >
                  <Trans i18nKey="p.p.s.view.later">Later</Trans>
                </button>
                <ConfirmDialog
                  placement="top"
                  confirmCallback={() => {
                    update();
                  }}
                >
                  <button className="btn btn-danger">
                    <Trans i18nKey="p.p.s.view.update">Update Now</Trans>
                  </button>
                </ConfirmDialog>
              </>
            )}
          </div>
        </Modal.Footer>
      </Modal>
      {loading && <OverLayLoader />}
    </>
  );
};

export default UpgradeModal4ScpV1;
